import { render, staticRenderFns } from "./image-uploader.component.vue?vue&type=template&id=3bfd8080"
import script from "./image-uploader.component.vue?vue&type=script&lang=js"
export * from "./image-uploader.component.vue?vue&type=script&lang=js"
import style0 from "./image-uploader.component.vue?vue&type=style&index=0&id=3bfd8080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports